import { gsap } from 'gsap';
import { WbScroller } from '../../webit_modules/wb-scroller/src';

export class WbAnimations {
  constructor() {
    const _this = this;

    this.addScroller();
    this.removeInitialLoading();
    this.init();

    document.addEventListener('_before_page_loaded', _this.init.bind(_this));
  }

  init() {
    return new Promise((resolve, reject) => {
      this.addAnims();
      resolve();
    });
  }

  addScroller() {
    this.scroller = window.WbScroller = new WbScroller({
      // scrollSmoother: {
      //   active: true,
      //   normalizeScroll: {
      //     allowNestedScroll: true,
      //   },
      // },
    });
    this.scroller.init();
  }

  wait(duration = 25) {
    return new Promise((resolve, reject) => {
      setTimeout(resolve, duration);
    });
  }

  removeInitialLoading() {
    const overlay = document.querySelector('.wb-load-overlay--initial');

    gsap.to(overlay, {
      opacity: 0,
      duration: 0.5,
      delay: 0.35,
      onComplete: () => {
        overlay._remove();
      },
    });
  }

  addAnims() {
    this.addMainSectionAnim();
  }

  addMainSectionAnim() {
    this.scroller.addAnim({
      element: '.wb-banner',
      trigger: '.wb-banner',
      scrollTrigger: {
        scrub: true,
        start: 'clamp(top bottom)',
        end: 'bottom top',
      },
      timeline: [
        {
          to: { y: 200 },
        },
      ],
    });

    this.scroller.addAnim({
      element: '#home-dossiers',
      trigger: '#home-dossiers',
      scrollTrigger: {
        scrub: true,
        start: 'clamp(bottom bottom)',
        end: 'bottom top',
      },
      timeline: [
        {
          to: { y: 200 },
        },
      ],
    });
  }
}
